var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagTranscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.68742 6.25004H5.31242V2.08337H4.68742V6.25004ZM3.54159 5.41671H4.16659V2.91671H3.54159V5.41671ZM2.49992 4.58337H3.12492V3.75004H2.49992V4.58337ZM5.83325 5.41671H6.45825V2.91671H5.83325V5.41671ZM6.87492 4.58337H7.49992V3.75004H6.87492V4.58337ZM0.833252 9.16671V0.833374H9.16658V7.50004H2.49992L0.833252 9.16671ZM1.66659 7.15629L2.15617 6.66671H8.33325V1.66671H1.66659V7.15629ZM1.66659 7.15629V1.66671V6.66671V7.15629Z",
    fill: "#193C6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagTranscription);
export default __webpack_public_path__ + "static/media/tag_transcription.f7a0d35b64559894d8847b8236d19294.svg";
export { ForwardRef as ReactComponent };